import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface InfoTooltipProps {
  title: React.ReactNode;
  placement?:
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'left'
    | 'left-end'
    | 'left-start'
    | 'right'
    | 'right-end'
    | 'right-start'
    | 'top'
    | 'top-end'
    | 'top-start';
  ariaLabel?: string;
  size?: 'small' | 'medium';
  color?: 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';
  sx?: any;
  fontSize?: string;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  placement = 'top',
  ariaLabel = 'More info',
  size = 'small',
  color = 'default',
  sx,
  fontSize = size,
}) => {
  return (
    <Tooltip title={title} placement={placement} arrow>
      <IconButton aria-label={ariaLabel} size={size} color={color} sx={{ p: 0.5, ...sx }}>
        <InfoOutlinedIcon sx={{ fontSize: fontSize }} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
